import React, { Fragment } from "react";

export default function NegotiationPages({ children }) {
  return <Fragment>{children}</Fragment>;
}
